module.exports = __webpack_public_path__ + "lp/img/info_icon.9735906c.svg";